// Used for the slider on https://stg.hooters.com/franchising/why-hooters/
$(document).ready(function() {
	// Initialize Value Prop Slider
	$('.hf-value-prop-slider').slick({
		initialSlide: 1,
		dots: true,
		dotsClass: 'slider__dots slider__dots--hf-value',
		infinite: false,
		speed: 300,
		slidesToShow: 2.5,
		centerMode: false,
		centerPadding: '0',
		arrows: true,
		prevArrow: 'slider__button slider__button--prev',
		nextArrow: 'slider__button slider__button--next',
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					//centerMode: true,
					centerPadding: '0'
				}
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 2,
					centerMode: false
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
					centerMode: false
				}
			}
			//   },
			//   {
			//     breakpoint: 480,
			//     settings: {
			// 	centerPadding: '40px'
			// }
			//   }
		]
	});

	$('.hf-value-prop-slider').slick('slickGoTo', 1, true);
	$('.hf-value-prop-slider').slick('slickGoTo', 0, true);

	// Initialize Content Slider
	$('.hf-content-slider').slick({
		initialSlide: 0,
		dots: true,
		dotsClass: 'slider__dots slider__dots--hf-content',
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: '320px',
		arrows: true,
		prevArrow: 'slider__button--prev',
		nextArrow: 'slider__button--next',
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					centerMode: true,
					centerPadding: '240px'
				}
			},
			{
				breakpoint: 769,
				settings: {
					centerPadding: '150px'
				}
			},
			{
				breakpoint: 480,
				settings: {
					centerPadding: '40px'
				}
			}
		]
	});

	$('.hf-content-slider').slick('slickGoTo', 1, true);
	$('.hf-content-slider').slick('slickGoTo', 0, true);
	
});
